module.exports = __webpack_public_path__ + "img/life-icon-yellow.372be6a2.png";